/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      // increment quantity
      $( 'body' ).on( 'click', '.increment-qty', function( e ) {
        e.preventDefault();
        const qtyInput = $( this ).siblings( 'input.qty' );
        const currentVal = parseInt( qtyInput.val() );
        const maxVal = parseInt( qtyInput.attr( 'max' ) );
        if ( !isNaN( maxVal ) && currentVal >= maxVal ) {
          return;
        }
        qtyInput.val( currentVal + 1 ).trigger( 'change' );
      } );

      // decrement quantity
      $( 'body' ).on( 'click', '.decrement-qty', function( e ) {
        e.preventDefault();
        const qtyInput = $( this ).siblings( 'input.qty' );
        const currentVal = parseInt( qtyInput.val() );
        const minVal = parseInt( qtyInput.attr( 'min' ) );
        if ( currentVal <= minVal ) {
          return;
        }
        qtyInput.val( currentVal - 1 ).trigger( 'change' );
      } );

      $( 'body' ).on( 'wc_cart_emptied', function() {
        $( '.ll-cart' ).addClass( 'll-cart__empty' );
        $( '.ll-banner' ).addClass( 'll-cart__empty' );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'woocommerce-quantity', COMPONENT );
} )( app );
